export const UNDEFINED_OPTION = "UNDEFINED_OPTION";
export const DEFAULT_FILTER_VALUE = "-1";
